export const gameConfig = {
  name: 'threecomboolympus',
  resolution: {
    width: 1080,
    height: 1920,
  },
  spinDuration: 0.6,
  reelDelay: 0.08,
  bounceDuration: 0.08,
  stopTimeThreshold: 2000,
  nodeWidth: 153,
  nodeHeight: 116,
  expandReelHeight: 696,
  containerHegiht: 580,
  squintTime: 3000,
  squintRate: 0.01,
  languageList: [
    'en',
    'ja',
    'zh',
    'es',
    'th',
    'id',
    'my',
    'ko',
    'ru',
    'vi',
    'fr',
    'pt',
    'hi',
    'ms',
    'es-es',
    'es-la',
    'pt-br',
    'pt-pt',
    'ar',
    'bn',
    'tr',
    'en-sc',
    'mm-sc',
  ],
}

export const gameSupportLanguages = ['EN', 'TH_TH', 'JA_JP', 'ID_ID', 'VI_VN', 'ZH_TW', 'ZH_CN']
